"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[6539],{

/***/ 97464:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23380);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92628);
/* harmony import */ var _components_App__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75615);
/* harmony import */ var _forms_validation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21265);





async function renderApp() {
  react_dom_client__WEBPACK_IMPORTED_MODULE_2__.createRoot(document.getElementById("app")).render(/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_App__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null));
}
renderApp();


/***/ }),

/***/ 96425:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61800);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4548);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);



const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(() => ({
  inheritFontWeight: {
    fontWeight: "inherit"
  }
}));
const ExpiryCell = ({ expiryDate }) => {
  const expiry = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(expiryDate, "YYYY-MM-DD");
  const classes = useStyles();
  const textColor = expiry.isBefore(dayjs__WEBPACK_IMPORTED_MODULE_1___default()()) ? "error" : "initial";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "body2",
    className: classes.inheritFontWeight,
    color: textColor
  }, expiry.format("MM / YYYY"));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpiryCell);


/***/ }),

/***/ 93240:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AO": () => (/* reexport */ LocationSelect),
  "es": () => (/* reexport */ LocationSelectWithAllOption),
  "N7": () => (/* reexport */ RHFLocationSelect)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var dist_module = __webpack_require__(34948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+react-hook-form-input@0.1.7_sjfm3rrfwwtsx5okgtvvldeidu/node_modules/@elephant-healthcare/react-hook-form-input/dist/module.js
var react_hook_form_input_dist_module = __webpack_require__(29054);
// EXTERNAL MODULE: ./src/client/inventory/hooks/useFacilityLocations.tsx + 1 modules
var useFacilityLocations = __webpack_require__(62174);
;// CONCATENATED MODULE: ./src/client/inventory/components/LocationSelect/LocationSelect.tsx




const LocationSelect = ({
  id,
  value,
  onChange,
  label,
  onBlur,
  onFocus,
  error,
  ...props
}) => {
  var _a;
  const { data: locations, loading } = (0,useFacilityLocations/* useFacilityLocations */.bx)();
  const options = (_a = locations == null ? void 0 : locations.map(({ _id, name }) => ({
    value: _id,
    label: name
  }))) != null ? _a : [];
  return /* @__PURE__ */ react.createElement(dist_module/* SelectField */.mg, {
    name: "location",
    id,
    "data-testid": id || props["data-testid"],
    fullWidth: true,
    required: true,
    label,
    options,
    error,
    selectProps: {
      "data-testid": "receive-location-select",
      value,
      disabled: loading,
      onChange: (e) => onChange(e.target.value),
      onBlur,
      onFocus,
      required: true
    }
  });
};
LocationSelect.defaultProps = {
  onFocus: void 0,
  onBlur: void 0
};
const RHFLocationSelect = ({
  id,
  label
}) => {
  var _a;
  const { data: locations, loading, error } = (0,useFacilityLocations/* useFacilityLocations */.bx)();
  const options = (_a = locations == null ? void 0 : locations.map(({ _id, name }) => ({
    value: _id,
    label: name
  }))) != null ? _a : [];
  return /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SelectField */.mg, {
    name: "locationId",
    id,
    "data-testid": id,
    fullWidth: true,
    required: true,
    label,
    options: options || [],
    selectProps: { disabled: loading || (locations == null ? void 0 : locations.length) === 0 },
    error: error == null ? void 0 : error.message,
    helperText: error == null ? void 0 : error.message
  });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(77572);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(64432);
;// CONCATENATED MODULE: ./src/client/inventory/components/LocationSelect/LocationSelectWithAllOption.tsx





const allLocations = "ALL_LOCATIONS";
function LocationSelectWithAllOption({ value, onChange }) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { data: locations, loading, error } = (0,useFacilityLocations/* useFacilityLocations */.bx)();
  const options = locations == null ? void 0 : locations.map(({ _id, name }) => ({
    value: _id,
    label: name
  }));
  return /* @__PURE__ */ react.createElement(dist_module/* SelectField */.mg, {
    name: "location",
    id: "inventory-overview-location-select",
    fullWidth: true,
    hideHelper: true,
    label: formatMessage({
      id: "inventory.overview.locationDropdown.placeholder",
      defaultMessage: "Location"
    }),
    options,
    selectProps: {
      value: value || allLocations,
      disabled: loading || (locations == null ? void 0 : locations.length) === 0,
      onChange: (e) => {
        const newValue = e.target.value;
        onChange(newValue === allLocations ? null : newValue);
      }
    },
    error: error == null ? void 0 : error.message,
    helperText: error == null ? void 0 : error.message
  }, /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    "data-testid": "select-option-facility-wide",
    key: "facility-wide",
    value: allLocations
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.overview.locationSelect.allLocationsOption",
    defaultMessage: "All Locations"
  })));
}

;// CONCATENATED MODULE: ./src/client/inventory/components/LocationSelect/index.ts




/***/ }),

/***/ 34010:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "l": () => (/* binding */ OptionWithStockLevel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52018);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12850);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95061);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61800);
/* harmony import */ var _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29054);
/* harmony import */ var _form_components_TextField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25262);
/* harmony import */ var elephant_web_style_icons_freshdeskWidgetIcon_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73922);
/* harmony import */ var _elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36547);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79226);
/* harmony import */ var use_debounce__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53890);
/* harmony import */ var _components_Inventory_SupplyLevelChip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64518);










const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((theme) => ({
  form: {
    marginTop: theme.spacing(2)
  },
  button: {
    float: "right"
  },
  root: {
    "& $element": {
      color: theme.palette.primary.contrastText
    }
  },
  link: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  noOptionsText: {
    display: (props) => props.showNoOptionsText ? "block" : "none"
  }
}));
const SKU_SEARCH_QUERY = _apollo_client__WEBPACK_IMPORTED_MODULE_7__/* .gql */ .Ps`
  query skuSearchInput($name: String, $facilityId: String!) {
    inventorySearchTmp(
      input: { name: $name, facilityId: $facilityId, active: true }
      options: { pageSize: 50, order: { by: NAME_RELAVANCE } }
    ) {
      edges {
        node {
          id
          name
          supplyLevel
          quantity
        }
      }
    }
  }
`;
const OptionWithStockLevel = ({
  name,
  quantity,
  supplyLevel
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "44px"
}, name, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
  marginLeft: 3
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Inventory_SupplyLevelChip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
  supplyLevel,
  quantity
})));
const SkuSearchInput = ({
  name,
  classes = {},
  required,
  renderOption,
  ...delegateProps
}) => {
  const client = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .useApolloClient */ .x)();
  const { facilityId } = (0,_elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_4__/* .useUserContext */ .SE)();
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
  const [searchTerm, setSearchTerm] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [options, setSkusDisplayed] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    []
  );
  const localClasses = useStyles({
    showNoOptionsText: options.length < 1 && !loading && !!searchTerm
  });
  const callback = (0,use_debounce__WEBPACK_IMPORTED_MODULE_11__/* .useDebouncedCallback */ .y1)(async (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    if (!(newSearchTerm == null ? void 0 : newSearchTerm.trim())) {
      return;
    }
    const trimmedSearchTerm = newSearchTerm == null ? void 0 : newSearchTerm.trim();
    setLoading(true);
    const { data } = await client.query({
      query: SKU_SEARCH_QUERY,
      variables: { name: trimmedSearchTerm, facilityId }
    });
    setLoading(false);
    const skus = (data == null ? void 0 : data.inventorySearchTmp.edges.map((edge) => edge.node)) || [];
    setSkusDisplayed(skus);
  }, 300);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_1__/* .Autocomplete */ .F2, {
    "aria-required": "false",
    name,
    id: "sku-search",
    fullWidth: true,
    loading,
    options,
    getOptionLabel: (option) => option.name,
    forcePopupIcon: false,
    classes: { noOptions: localClasses.noOptionsText, ...classes },
    onInputChange: (_, val) => callback(val),
    getOptionSelected: (option, value) => (option == null ? void 0 : option.id) === (value == null ? void 0 : value.id),
    noOptionsText: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      display: "flex",
      alignItems: "center"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      pr: 2
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
      style: { height: 30, width: 30 },
      alt: formatMessage({
        id: "inventory.form.receive.skuSearch.noOptions.icon.alt",
        defaultMessage: "Helpdesk icon"
      }),
      src: elephant_web_style_icons_freshdeskWidgetIcon_svg__WEBPACK_IMPORTED_MODULE_3__
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      variant: "body2"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
      id: "inventory.form.receive.skuSearch.noOptions.text",
      defaultMessage: "Can\u2019t find the item you\u2019re looking for?"
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      variant: "body2",
      color: "secondary",
      role: "button",
      classes: { root: localClasses.link },
      onMouseDown: () => {
        var _a;
        return (_a = window.fcWidget) == null ? void 0 : _a.open();
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
      id: "inventory.form.receive.skuSearch.noOptions.button.text",
      defaultMessage: "Contact us on Helpdesk"
    })))),
    renderOption,
    renderInput: (errStr) => (params) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_form_components_TextField__WEBPACK_IMPORTED_MODULE_2__/* .TextField */ .n, {
      ...params,
      label: formatMessage({
        id: "inventory.form.receive.skuSearch.label",
        defaultMessage: "Find Product"
      }),
      variant: "outlined",
      "data-testid": "sku-search",
      InputProps: {
        ...params.InputProps,
        type: "search"
      },
      error: errStr,
      required
    }),
    ...delegateProps
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SkuSearchInput);


/***/ }),

/***/ 15054:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": () => (/* binding */ SortBySelect)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80758);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35795);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18464);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64432);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52018);



const styles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => ({
  select: {
    fontWeight: 600
  }
}));
const SortBySelect = (props) => {
  var _a;
  const { options, value, onChange } = props;
  const classes = styles();
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const optionsMap = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(
    () => options.reduce(
      (map, option) => map.set(option.label, option),
      /* @__PURE__ */ new Map()
    ),
    [options]
  );
  const handleChange = (event) => onChange(optionsMap.get(event.target.value));
  const label = formatMessage({
    id: "inventory.overview.list.sort.label",
    defaultMessage: "Sort By"
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "outlined",
    fullWidth: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    id: "sortByLabel"
  }, label), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    labelId: "sortByLabel",
    id: "sortBySelect",
    value: (_a = value == null ? void 0 : value.label) != null ? _a : "",
    renderValue: (optionLabel) => {
      var _a2;
      return (_a2 = optionsMap.get(optionLabel)) == null ? void 0 : _a2.label;
    },
    onChange: handleChange,
    label,
    classes,
    "data-testid": "inventoryOverviewSortSelect"
  }, options.map((option) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    key: option.label,
    value: option.label
  }, option.label))));
};


/***/ }),

/***/ 30623:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61800);


const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => ({
  name: {
    textTransform: "capitalize"
  }
}));
const UserName = ({ name }) => {
  const classes = useStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    variant: "body2",
    className: classes.name
  }, name);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UserName);


/***/ }),

/***/ 39659:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ chipColors)
/* harmony export */ });
const chipColors = {
  positive: "primary",
  negative: "prescription",
  neutral: "darkerGrey"
};


/***/ }),

/***/ 6944:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xc": () => (/* reexport */ components_FractionChip),
  "ae": () => (/* reexport */ PageLayout_InventoryHeader),
  "Ac": () => (/* reexport */ components_InventoryTitleRow),
  "es": () => (/* reexport */ LocationSelect/* LocationSelectWithAllOption */.es),
  "zX": () => (/* reexport */ SortBySelect/* SortBySelect */.z),
  "vx": () => (/* reexport */ UserName/* default */.Z)
});

// UNUSED EXPORTS: ExpiryCell, LocationSelect, RHFLocationSelect, SkuSearchInput

// EXTERNAL MODULE: ./src/client/inventory/components/ExpiryCell.tsx
var ExpiryCell = __webpack_require__(96425);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-chip@0.1.9_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-chip/dist/module.js
var dist_module = __webpack_require__(85810);
// EXTERNAL MODULE: ./src/client/inventory/components/constants.tsx
var constants = __webpack_require__(39659);
;// CONCATENATED MODULE: ./src/client/inventory/components/FractionChip.tsx



const FractionChip = ({ numerator, denominator }) => {
  let color = constants/* chipColors.positive */.y.positive;
  if (numerator < denominator) {
    color = constants/* chipColors.negative */.y.negative;
  }
  return /* @__PURE__ */ react.createElement(dist_module/* Chip */.A, {
    label: `${numerator} / ${denominator}`,
    color
  });
};
/* harmony default export */ const components_FractionChip = (FractionChip);

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-link@0.2.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-link/dist/module.js
var mui_link_dist_module = __webpack_require__(40252);
;// CONCATENATED MODULE: ./src/client/inventory/components/InventoryTitleRow.tsx






const InventoryTitleRow = ({
  title,
  backToLink,
  children
}) => {
  const navigate = (0,dist/* useNavigate */.s0)();
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginBottom: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2,
    justifyContent: "space-between",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    sm: "auto",
    md: "auto"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginRight: 1
  }, backToLink ? /* @__PURE__ */ react.createElement(mui_link_dist_module/* UnstyledLink */.H, {
    to: backToLink,
    onClick: () => navigate(-1)
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
    color: "tertiary"
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.ArrowBackIcon, null))) : /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
    color: "tertiary",
    onClick: () => {
      navigate(-1);
    }
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.ArrowBackIcon, null))), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h3"
  }, title))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    sm: "auto"
  }, children)));
};
/* harmony default export */ const components_InventoryTitleRow = (InventoryTitleRow);

// EXTERNAL MODULE: ./src/client/inventory/components/SkuSearchInput.tsx
var SkuSearchInput = __webpack_require__(34010);
// EXTERNAL MODULE: ./src/client/inventory/components/UserName.tsx
var UserName = __webpack_require__(30623);
// EXTERNAL MODULE: ./src/client/inventory/components/SortBySelect.tsx
var SortBySelect = __webpack_require__(15054);
// EXTERNAL MODULE: ./src/client/inventory/components/LocationSelect/index.ts + 2 modules
var LocationSelect = __webpack_require__(93240);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@6.15.0_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-router-dom/dist/index.js
var react_router_dom_dist = __webpack_require__(58311);
// EXTERNAL MODULE: ./src/client/inventory/routing/links.ts
var links = __webpack_require__(57706);
;// CONCATENATED MODULE: ./src/client/inventory/components/PageLayout/InventoryHeaderLeftContent.tsx





const useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  whiteText: {
    color: theme.palette.common.white
  }
}));
const InventoryHeaderLeftContent = () => {
  const classes = useStyles();
  return /* @__PURE__ */ react.createElement(react_router_dom_dist/* Link */.rU, {
    to: (0,links/* linkToInventoryManagement */.R$)(),
    style: { textDecoration: "none" }
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h4",
    align: "left",
    className: classes.whiteText
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.header.title",
    defaultMessage: "Inventory"
  })));
};
/* harmony default export */ const PageLayout_InventoryHeaderLeftContent = (InventoryHeaderLeftContent);

// EXTERNAL MODULE: ./src/client/components/Layout/Header/index.tsx + 1 modules
var Header = __webpack_require__(14187);
;// CONCATENATED MODULE: ./src/client/inventory/components/PageLayout/InventoryHeader.tsx



const InventoryHeader = (props) => {
  return /* @__PURE__ */ react.createElement(Header/* default */.Z, {
    ...props,
    leftContent: /* @__PURE__ */ react.createElement(PageLayout_InventoryHeaderLeftContent, null)
  });
};
/* harmony default export */ const PageLayout_InventoryHeader = (InventoryHeader);

;// CONCATENATED MODULE: ./src/client/inventory/components/PageLayout/index.ts


;// CONCATENATED MODULE: ./src/client/inventory/components/index.ts










/***/ }),

/***/ 26445:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": () => (/* binding */ DateRangePicker)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52018);
/* harmony import */ var _elephant_healthcare_mui_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34948);



const DateRangePicker = (props) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_input__WEBPACK_IMPORTED_MODULE_1__/* .DateRangePicker */ .Dw, {
    ...props,
    labelFrom: formatMessage({
      id: "dateRangePicker.from",
      defaultMessage: "From"
    }),
    labelTo: formatMessage({
      id: "dateRangePicker.to",
      defaultMessage: "To"
    })
  });
};


/***/ }),

/***/ 93004:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ RHFTextField)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52018);
/* harmony import */ var _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29054);



const RHFTextField = (props) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_1__/* .TextField */ .nv, {
    ...props,
    clearButtonTitle: formatMessage({
      id: "textField.clear",
      defaultMessage: "Clear"
    })
  });
};


/***/ }),

/***/ 25262:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ TextField)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52018);
/* harmony import */ var _elephant_healthcare_mui_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34948);



const TextField = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(
  (props, ref) => {
    const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_input__WEBPACK_IMPORTED_MODULE_1__/* .TextField */ .nv, {
      ...props,
      ref,
      clearButtonTitle: formatMessage({
        id: "textField.clear",
        defaultMessage: "Clear"
      })
    });
  }
);


/***/ }),

/***/ 41907:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": () => (/* binding */ formatUserName),
/* harmony export */   "DZ": () => (/* binding */ formatDatetime),
/* harmony export */   "p6": () => (/* binding */ formatDate)
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4548);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

function formatDate(date) {
  if (!date)
    return "";
  return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("DD/MM/YYYY");
}
function formatDatetime(date) {
  if (!date)
    return "";
  return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("DD/MM/YYYY HH:mm");
}
function formatUserName(user) {
  var _a, _b;
  if (!user)
    return "";
  return `${((_a = user.person) == null ? void 0 : _a.firstname) || ""} ${((_b = user.person) == null ? void 0 : _b.lastname) || ""}`;
}


/***/ }),

/***/ 62174:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vT": () => (/* binding */ useFacilityLocationName),
  "bx": () => (/* binding */ useFacilityLocations),
  "UR": () => (/* binding */ useGetFacilityLocationName)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/inventory/hooks/__generated__/useFacilityLocations.gql.ts


const defaultOptions = {};
const InventoryFacilityLocationsDocument = lib/* gql */.Ps`
    query inventoryFacilityLocations($facilityId: String!) {
  facilityLocations(input: {clinicUuids: [$facilityId], active: true}) {
    _id
    name
  }
}
    `;
function useInventoryFacilityLocationsQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InventoryFacilityLocationsDocument, options);
}
function useInventoryFacilityLocationsLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InventoryFacilityLocationsDocument, options);
}

;// CONCATENATED MODULE: ./src/client/inventory/hooks/useFacilityLocations.tsx



lib/* gql */.Ps`
  query inventoryFacilityLocations($facilityId: String!) {
    facilityLocations(input: { clinicUuids: [$facilityId], active: true }) {
      _id
      name
    }
  }
`;
function useFacilityLocations() {
  const { facilityId } = (0,dist_module/* useUserContext */.SE)();
  const { data, loading, error } = useInventoryFacilityLocationsQuery({
    variables: {
      facilityId
    },
    skip: !facilityId
  });
  const facilityLocations = data == null ? void 0 : data.facilityLocations;
  return { data: facilityLocations, loading, error };
}
function useFacilityLocationName(locationId) {
  var _a;
  const { facilityId } = (0,dist_module/* useUserContext */.SE)();
  const { data } = useInventoryFacilityLocationsQuery({
    variables: {
      facilityId
    },
    skip: !facilityId
  });
  return (_a = data == null ? void 0 : data.facilityLocations.find(({ _id }) => _id === locationId)) == null ? void 0 : _a.name;
}
function useGetFacilityLocationName() {
  const { facilityId } = (0,dist_module/* useUserContext */.SE)();
  const { data } = useInventoryFacilityLocationsQuery({
    variables: {
      facilityId
    },
    skip: !facilityId
  });
  return (locationId) => {
    var _a;
    return (_a = data == null ? void 0 : data.facilityLocations.find(({ _id }) => _id === locationId)) == null ? void 0 : _a.name;
  };
}


/***/ }),

/***/ 85655:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HV": () => (/* reexport */ request_list/* ActionedMoveRequestOverview */.H),
  "v1": () => (/* reexport */ fulfilment/* default */.Z),
  "JE": () => (/* reexport */ stocktake_history/* HistoricStockTakeOverview */.J),
  "LU": () => (/* reexport */ initiate/* default */.Z),
  "$0": () => (/* reexport */ audit_InventoryAudit),
  "Q$": () => (/* reexport */ InventoryManagementPage/* default */.Z),
  "wE": () => (/* reexport */ new_request/* default */.Z),
  "JU": () => (/* reexport */ request_list/* MoveRequests */.J),
  "EY": () => (/* reexport */ OngoingStockTake/* default */.Z),
  "aj": () => (/* reexport */ stocktake_history/* StockTakeHistory */.a),
  "De": () => (/* reexport */ StockTakeReview/* default */.Z)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-page@0.4.3_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-page/dist/index.js
var dist = __webpack_require__(48534);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./src/client/inventory/form-components/DateRangePicker.tsx
var DateRangePicker = __webpack_require__(26445);
// EXTERNAL MODULE: ./src/client/inventory/components/index.ts + 5 modules
var components = __webpack_require__(6944);
// EXTERNAL MODULE: ./src/client/inventory/routing/links.ts
var links = __webpack_require__(57706);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var react_router_dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
;// CONCATENATED MODULE: ./src/client/inventory/hooks/useUpdateQueryParamCallback.ts


function useUpdateQueryParamCallback({
  linkFactory
}) {
  const queryParams = (0,useQuerystring/* default */.Z)();
  const navigate = (0,react_router_dist/* useNavigate */.s0)();
  return (varName) => (value) => {
    navigate(linkFactory({ ...queryParams, [varName]: value }));
  };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./src/client/inventory/formatting.ts
var formatting = __webpack_require__(41907);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/inventory/pages/audit/__generated__/InventoryAuditTable.gql.ts


const defaultOptions = {};
const InventoryAuditTableDocument = lib/* gql */.Ps`
    query inventoryAuditTable($input: InventoryHistoryInput!, $options: InventoryHistoryOptions) {
  inventoryHistory(input: $input, options: $options) {
    totalCount
    items {
      timestamp
      eventType
      location {
        name
      }
      skuName
      user {
        person {
          firstname
          lastname
        }
      }
    }
  }
}
    `;
function useInventoryAuditTableQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InventoryAuditTableDocument, options);
}
function useInventoryAuditTableLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InventoryAuditTableDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(11313);
;// CONCATENATED MODULE: ./src/client/inventory/pages/audit/useAuditEventTypeMapping.ts

const messages = (0,react_intl_lib/* defineMessages */.vU)({
  LOT_RECEIVED: {
    id: "inventory.audit.eventType.LOT_RECEIVED",
    defaultMessage: "Inventory Received"
  },
  LOT_UPDATED: {
    id: "inventory.audit.eventType.LOT_UPDATED",
    defaultMessage: "Inventory Updated"
  },
  PRESCRIPTION_DISPENSED: {
    id: "inventory.audit.eventType.PRESCRIPTION_DISPENSED",
    defaultMessage: "Prescription Dispensed"
  },
  STOCK_TAKE_START: {
    id: "inventory.audit.eventType.STOCK_STAKE_START",
    defaultMessage: "Start Stocktake"
  },
  STOCK_TAKE_FINALISE: {
    id: "inventory.audit.eventType.STOCK_TAKE_FINALISE",
    defaultMessage: "Complete Stocktake"
  },
  MOVE_REQUEST_FULFILLED: {
    id: "inventory.audit.eventType.MOVE_REQUEST_FULFILLED",
    defaultMessage: "Fulfill Move Request"
  },
  STOCK_MOVED_FROM: {
    id: "inventory.audit.eventType.STOCK_MOVED_FROM",
    defaultMessage: "Moved From"
  },
  STOCK_MOVED_TO: {
    id: "inventory.audit.eventType.STOCK_MOVED_TO",
    defaultMessage: "Moved To"
  }
});
function useAuditEventTypeMapping() {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return (eventType) => messages[eventType] ? formatMessage(messages[eventType]) : eventType;
}

// EXTERNAL MODULE: ./src/client/components/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(64493);
;// CONCATENATED MODULE: ./src/client/inventory/pages/audit/InventoryAuditTable.tsx










lib/* gql */.Ps`
  query inventoryAuditTable($input: InventoryHistoryInput!, $options: InventoryHistoryOptions) {
    inventoryHistory(input: $input, options: $options) {
      totalCount
      items {
        timestamp
        eventType
        location {
          name
        }
        skuName
        user {
          person {
            firstname
            lastname
          }
        }
      }
    }
  }
`;
const InventoryAuditTable = ({
  pageSize = 20,
  locationId,
  skuId,
  startDate,
  endDate
}) => {
  var _a, _b, _c;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const tableColumns = [
    {
      field: "date",
      headerName: formatMessage({
        id: "inventory.audit.table.columnLabel.date",
        defaultMessage: "Date"
      }),
      flex: 1
    },
    {
      field: "user",
      headerName: formatMessage({
        id: "inventory.audit.table.columnLabel.user",
        defaultMessage: "Done By"
      }),
      flex: 2,
      renderCell: (val) => /* @__PURE__ */ react.createElement(components/* UserName */.vx, {
        name: val
      })
    },
    {
      field: "eventType",
      headerName: formatMessage({
        id: "inventory.audit.table.columnLabel.eventType",
        defaultMessage: "Action"
      }),
      flex: 2
    },
    {
      field: "location",
      headerName: formatMessage({
        id: "inventory.audit.table.columnLabel.location",
        defaultMessage: "Location"
      }),
      flex: 2
    },
    {
      field: "sku",
      headerName: formatMessage({
        id: "inventory.audit.table.columnLabel.sku",
        defaultMessage: "Item Name"
      }),
      flex: 2
    }
  ];
  const { facilityId } = (0,dist_module/* useUserContext */.SE)();
  const mapEventType = useAuditEventTypeMapping();
  const [currentPage, setCurrentPage] = (0,react.useState)(0);
  const { data, loading, error } = useInventoryAuditTableQuery({
    variables: {
      input: {
        facilityId,
        locationId,
        skuId
      },
      options: {
        pageNumber: currentPage,
        pageSize,
        startDate,
        endDate
      }
    },
    fetchPolicy: "cache-and-network"
  });
  if (error) {
    return /* @__PURE__ */ react.createElement(ErrorPage/* default */.Z, {
      error
    });
  }
  const mappedData = (_b = (_a = data == null ? void 0 : data.inventoryHistory) == null ? void 0 : _a.items) == null ? void 0 : _b.map((item) => {
    var _a2;
    const user = (0,formatting/* formatUserName */.BD)(item.user);
    return {
      id: `${item.timestamp}-${item.eventType}-${user}`,
      date: (0,formatting/* formatDatetime */.DZ)(item.timestamp),
      eventType: mapEventType(item.eventType),
      user,
      sku: item.skuName,
      location: (_a2 = item.location) == null ? void 0 : _a2.name
    };
  });
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    loading,
    columns: tableColumns,
    rows: mappedData != null ? mappedData : [],
    noDataMessage: formatMessage({
      id: "inventory.audit.list.noData",
      defaultMessage: "No entries found."
    }),
    pagination: {
      page: currentPage,
      pageSize,
      totalRows: (_c = data == null ? void 0 : data.inventoryHistory) == null ? void 0 : _c.totalCount,
      handlePageChange: (newPageNumber) => {
        setCurrentPage(newPageNumber);
      }
    }
  });
};
/* harmony default export */ const audit_InventoryAuditTable = (InventoryAuditTable);

;// CONCATENATED MODULE: ./src/client/inventory/pages/audit/InventoryAudit.tsx











const InventoryAudit = () => {
  const queryParams = (0,useQuerystring/* default */.Z)();
  const { locationId, startDate = null, endDate = null } = queryParams;
  const makeUpdateQueryParam = useUpdateQueryParamCallback({
    analyticsNamespace: "inventory.audit",
    linkFactory: links/* linkToInventoryAudit */.qA
  });
  const setLocationId = makeUpdateQueryParam("locationId");
  const setStartDate = makeUpdateQueryParam("startDate");
  const setEndDate = makeUpdateQueryParam("endDate");
  return /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, /* @__PURE__ */ react.createElement(components/* InventoryHeader */.ae, null), /* @__PURE__ */ react.createElement(dist.Page, {
    "data-dense": true
  }, /* @__PURE__ */ react.createElement(components/* InventoryTitleRow */.Ac, {
    backToLink: (0,links/* linkToInventoryManagement */.R$)(),
    title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.audit.title",
      defaultMessage: "Inventory Audit"
    })
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2,
    justifyContent: "space-between",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    sm: 6
  }, /* @__PURE__ */ react.createElement(components/* LocationSelectWithAllOption */.es, {
    value: locationId,
    onChange: setLocationId
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    sm: 6
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(DateRangePicker/* DateRangePicker */.D, {
    hideHelper: true,
    clearable: true,
    fromValue: startDate,
    setFromValue: setStartDate,
    toValue: endDate,
    setToValue: setEndDate
  }))))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginTop: 4
  }, /* @__PURE__ */ react.createElement(audit_InventoryAuditTable, {
    startDate,
    endDate,
    locationId
  }))));
};
/* harmony default export */ const audit_InventoryAudit = (InventoryAudit);

;// CONCATENATED MODULE: ./src/client/inventory/pages/audit/index.tsx


// EXTERNAL MODULE: ./src/client/inventory/pages/inventory-overview/InventoryManagementPage.tsx + 24 modules
var InventoryManagementPage = __webpack_require__(46774);
// EXTERNAL MODULE: ./src/client/inventory/pages/move-requests/new-request/index.ts + 5 modules
var new_request = __webpack_require__(89467);
// EXTERNAL MODULE: ./src/client/inventory/pages/move-requests/request-list/index.ts + 8 modules
var request_list = __webpack_require__(23323);
// EXTERNAL MODULE: ./src/client/inventory/pages/move-requests/fulfilment/index.ts + 8 modules
var fulfilment = __webpack_require__(45216);
// EXTERNAL MODULE: ./src/client/inventory/pages/stocktake/ongoing/OngoingStockTake.tsx + 6 modules
var OngoingStockTake = __webpack_require__(89189);
// EXTERNAL MODULE: ./src/client/inventory/pages/stocktake/history/index.ts + 5 modules
var stocktake_history = __webpack_require__(20594);
// EXTERNAL MODULE: ./src/client/inventory/pages/stocktake/initiate/index.ts + 2 modules
var initiate = __webpack_require__(74725);
// EXTERNAL MODULE: ./src/client/inventory/pages/stocktake/review/StockTakeReview.tsx + 3 modules
var StockTakeReview = __webpack_require__(98019);
;// CONCATENATED MODULE: ./src/client/inventory/pages/index.ts











/***/ })

}]);